export default __webpack_public_path__ + "static/media/Identify-Strategy.054f7508.svg";